import { BrameCampaign } from 'api/brameCampaigns'
import React from 'react'
import GameCard from './GameCard'

interface GameCardListProps {
  games: BrameCampaign[]
  onAddToHomepage?: (gameId: string) => void
  onMenuAction?: (gameId: string, action: string) => void
  getGameHomepageStatus?: (gameId: string) => {
    exists: boolean
    blockId?: number
  }
}

const GameCardList = ({
  games,
  onAddToHomepage,
  onMenuAction,
  getGameHomepageStatus,
}: GameCardListProps) => {
  return (
    <div className="d-flex flex-column" style={{ gap: '24px' }}>
      {games.map(game => {
        const homepageStatus = getGameHomepageStatus?.(game.id) ?? {
          exists: false,
        }
        return (
          <GameCard
            key={game.id}
            game={game}
            onAddToHomepage={() => {
              onAddToHomepage?.(game.id)
            }}
            onMenuAction={onMenuAction}
            homepageStatus={homepageStatus}
          />
        )
      })}
    </div>
  )
}

export default GameCardList
